import React from 'react';
import PropTypes from 'prop-types';
import Nav from './Nav';
import styles from './header.module.scss';

const Header = ({articleNavigation}) => (
  <header className={styles.Header}>
    <Nav articleTree={articleNavigation} />
  </header>
);

Header.propTypes = {
  articleNavigation: PropTypes.objectOf(PropTypes.object).isRequired,
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/header/index.js